// Export all components for easy importing
import AllergenList from './AllergenList.vue';
import Carousel from './Carousel.vue';
import CodeLogIn from './CodeLogIn.vue';
import Confirm from './Confirm.vue';
import DayOperatingHours from './DayOperatingHours.vue';
import LoadingSpinner from './LoadingSpinner.vue';
import ModifierModal from './ModifierModal.vue';
import ProductModal from './ProductModal.vue';
import SingleInput from './SingleInput.vue';
import Theme from './Theme.vue';
import ToggleSwitch from './ToggleSwitch.vue';
import Unauthenticated from './Unauthenticated.vue';
import Warning from './Warning.vue';
import Login from './Login.vue';
import PaymentTerminalModal from './PaymentTerminalModal.vue';
import CompanionModal from './CompanionModal.vue';
import OperatingHours from './OperatingHours.vue';
import CurrencyFormatter from './CurrencyFormatter.vue';
import ApplyModal from './ApplyModal.vue';
import ManagerCheckModal from './ManagerCheckModal.vue';


// Named exports for tree shaking
export {
  AllergenList,
  Carousel,
  CodeLogIn,
  Confirm,
  DayOperatingHours,
  LoadingSpinner,
  ModifierModal,
  ProductModal,
  SingleInput,
  Theme,
  ToggleSwitch,
  Unauthenticated,
  Warning,
  Login,
  PaymentTerminalModal,
  CompanionModal,
  OperatingHours,
  CurrencyFormatter,
  ApplyModal,
  ManagerCheckModal,
};

// Default export for convenience
export default {
  AllergenList,
  Carousel,
  CodeLogIn,
  Confirm,
  DayOperatingHours,
  LoadingSpinner,
  ModifierModal,
  ProductModal,
  SingleInput,
  Theme,
  ToggleSwitch,
  Unauthenticated,
  Warning,
  Login,
  PaymentTerminalModal,
  CompanionModal,
  OperatingHours,
  CurrencyFormatter,
  ApplyModal,
  ManagerCheckModal,
};

// For Vue.use() plugin installation
export const ComponentsPlugin = {
  install(app) {
    // Register all components globally
    app.component('AllergenList', AllergenList);
    app.component('Carousel', Carousel);
    app.component('CodeLogIn', CodeLogIn);
    app.component('Confirm', Confirm);
    app.component('DayOperatingHours', DayOperatingHours);
    app.component('LoadingSpinner', LoadingSpinner);
    app.component('ModifierModal', ModifierModal);
    app.component('ProductModal', ProductModal);
    app.component('SingleInput', SingleInput);
    app.component('Theme', Theme);
    app.component('ToggleSwitch', ToggleSwitch);
    app.component('Unauthenticated', Unauthenticated);
    app.component('Warning', Warning);
    app.component('Login', Login);
    app.component('PaymentTerminalModal', PaymentTerminalModal);
    app.component('CompanionModal', CompanionModal);
    app.component('OperatingHours', OperatingHours);
    app.component('CurrencyFormatter', CurrencyFormatter);
    app.component('ApplyModal', ApplyModal);
    app.component('ManagerCheckModal', ManagerCheckModal);
  }
};